import React from 'react';
import { ResponseContainer } from './DisplayContainer';
import styled from 'styled-components';
import {
  convertFromJsonOrReturnValue,
  isJson,
} from 'lib/utils/WYSIWYGEditorHelper';
import { stateToHTML } from 'draft-js-export-html';

const OpenTextDisplay = (props) => {
  const { value } = props;

  return (
    <ResponseContainer>
      {isJson(value) ? (
        <SDiv
          dangerouslySetInnerHTML={{
            __html: stateToHTML(convertFromJsonOrReturnValue(value)),
          }}
        />
      ) : (
        <SDiv>{value}</SDiv>
      )}
    </ResponseContainer>
  );
};

export default OpenTextDisplay;

const SDiv = styled.div`
  && {
    margin: 0 5px;
  }
`;
